<template>
    <el-dialog :visible.sync="dialogFormVisible">
        <div class="header flex jcb">
            <span class="fs18 color_333 bold">{{docInfo.hosName}}</span>
            <span class="color_main fs15">{{formatterStatus(info.status)}}</span>
        </div>
        <div class="color_999 fs14 mt5 mb10">
            <p>处方编号：{{info.orderNo}}</p>
            <p>开方时间：{{info.createTime|timeFormat("%Y/%m/%d %H:%M")}}</p>
        </div>
        <div class="bt pt5 pb5 bbd">
            <p>
                <span>患者姓名：{{info.compatName}}</span>
                <span class="ml10">性别：{{info.compatGender|sexFilter(1)}}</span>
                <span class="ml10">年龄：{{info.compatAge}}</span>
            </p>
            <p>初步诊断：{{info.diagnosis}}</p>
        </div>
        <div class="mt10">
            <div class="flex check_title">
                <img v-if="info.orderType==='WESTERN_RECIPE'"
                     src="../../assets/icon/prescription/medicine.png" alt="">
                <img v-else src="../../assets/icon/prescription/zhongyao.png" alt="">
                <span class="fs16 bold ml10">{{info.orderType|filter_drug_type}}药品</span></div>
            <div v-if="info.orderType==='WESTERN_RECIPE'" class="flex column bb">
                <div class="flex column pt10 pb10" :class="{btd:index>0}" v-for="(k,index) in info.drugList">
                    <div class="flex jcb">
                        <p><span>{{k.drugName}}</span><span class="ml20">{{k.drugSpecification}}</span></p>
<!--                        <span>￥{{k.drugUnitPrice/100}}</span>-->
                    </div>
                    <div class="flex jcb">
                        <p>
                            <span>用法用量：</span>
                            <span>
                                {{k.admission}}，{{k.frequencyName}}，每次{{k.dosage}}{{k.dosageUnit}}, 用药{{k.useDays}}天
                            </span>
                        </p>
                        <span>x {{k.amount}}{{k.drugUnit}}</span>
                    </div>
                    <div v-if="info.orderType==='WESTERN_RECIPE'">
                        <p>补充说明：{{k.remarks}}</p>
                    </div>
                </div>
            </div>
            <div v-else>
               <ul class="pt20 pr30">
                        <li v-for="(item, index) in drugList" :key="index" class="flex space-between">
                            <span>{{item.ypmc||item.drugName}}</span>
                            <span class="pl15 color_main3">
                                {{item.ypsl||item.dosage}}{{item.jldw||item.dosageUnit}}
                            </span>
                            <span class="pl15">{{item.admission|filter_jianfu}}</span>
                        </li>
                    </ul>
               <p class="mt30 dash"></p>
            </div>
            <div v-if="info.orderType==='CHINESE_RECIPE'">
                <p>共{{this.drugList.length}}味药，{{this.info.tcmDosage}}付</p>
                <p>用法用量：{{info.tcmAdmission}}</p>
            </div>

            <div class="mt20 flex jca">
                <div class="flex1 flex column jcc">
                    <span class="fs14 color_333">处方医生:</span>
                    <!--<img v-if="info.openStamp" :src="'data:image/png;base64,'+info.openStamp" alt="" class="width50">-->
                    <img v-if="info.openStamp" :src="info.openStamp" alt="" class="width50">
                    <span v-else>{{info.docName}}</span>
                </div>
                <div class="flex1 flex column">
                    <span class="fs14 color_333">审核医生:</span>
                    <img :src="'data:image/png;base64,'+info.auditStamp" alt="" class="width50"
                         v-if="info.auditStamp && info.status!=='ISSUE'">
                    <span v-else-if="info.status==='ISSUE'"> 暂未审核</span>
                    <span v-else>{{info.auditorName}}</span>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer" v-if="info.status==='ISSUE'">
            <el-button size="mini" @click="sub('refuse')">审核拒绝</el-button>
            <el-button type="primary" @click="sub('accept')" size="mini">审核通过</el-button>
        </div>
    </el-dialog>
</template>

<script>
  import {timeFormat, sex} from "ty-vue-filters";
  import {sexFilter} from "../../lib/filters";
  import {filter_drug_type} from "../../filters/prescription";

  export default {
    name: "check-prescription-dialog",
    props: {
      info: {
        type: Object,
        default: () => {
          return {}
        }
      }
    },
    data() {
      return {
            dialogFormVisible: false,
            form: {
              recordId: this.info.recordId,
              teamId: this.info.teamId,
              serveIds: []
            },
          drugList: [],
      }
    },
    filters: {
      sexFilter,
      timeFormat,
      filter_drug_type,
      filter_jianfu(str){
            if (!str) return ''
            if (str === '煎服'){
                return ''
            } else {
                return str
            }
        }
    },
    methods: {
      show() {
        this.dialogFormVisible = true;
      },
      close(){
        this.dialogFormVisible = false;
      },
      async sub(h) {
        this.$emit('handler',h)
      },
      formatterStatus(code) {
        const statusObj = {
          RECALL: "已召回",
          REFUSE: "已拒绝",
          ISSUE: "待审核",
          AUDIT: "已审核",
          PAY: "已审核",
          WAITTAKE: "已审核",
          SHIPPING: "已审核",
          COMPLETE: "已审核",
          COMMENT: "已审核",
          CANCEL: "已作废",
        };
        return statusObj[code];
      },
    },
    watch:{
        info:{
            handler(newV){
                this.drugList = newV.drugList
            },
        }
    }
  }
</script>

<style scoped lang="scss">
    .management-contract {
        .el-form {
            /*border-top: none;*/
        }
    }
    .bbd{
        border-bottom: 1px #E5E5E5 dashed;
    }
    .btd{
        border-top: 1px #E5E5E5 dashed;
    }
    .check_title{
        img{
            width: 20px;
            height: 20px;
        }
    }

    .dash {
        border-top: 1px dashed #f1f1f1;
        height: 15px;
    }

</style>
